import React, { useEffect, useRef } from "react";
import frames from "../assets/frames.png"; // Update with the correct path

function RotatedImageSection() {
  return (
   
      <div className="image-container">
        <img
          //   ref={imageRef}
          src={frames}
          alt="Rotated Phone Display"
          className="h-[400px] md:h-full lg:h-full object-cover "
        />
      </div>
    
  );
}

export default RotatedImageSection;
